import { Button } from "components/Button";
import { Modal } from "components/Modal";
import type { ModalProps } from "components/Modal/Modal.model";
import type { ThemeProps as Props } from "models/styles/theme";
import styled from "styled-components";
import { calculateRem } from "styles/mixins/calculateRem";

type StyledModalProps = ModalProps & Props;

export const StyledIntakeExamModal = styled(Modal)<StyledModalProps>`
  background-color: ${({ theme }: StyledModalProps) => theme.palette.neutral.white};
  width: ${calculateRem(541)};
  padding: 2rem 1rem;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  text-align: left;
`;

export const StyledButton = styled(Button)`
  width: 15.5rem;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  font-weight: 400;
  border-radius: 7px;
`;
